export const colors = {
  //palette
  palettePrimary: '#232323',
  paletteSecondary: '#ffffff',
  //colors
  primaryPurple: '#232323',
  primaryLightPurple: '#f6eee1',
};
